import { render, staticRenderFns } from "./AmericasmedicalcityReservaUti.vue?vue&type=template&id=a94e8d0c&scoped=true"
import script from "./AmericasmedicalcityReservaUti.vue?vue&type=script&lang=ts"
export * from "./AmericasmedicalcityReservaUti.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94e8d0c",
  null
  
)

export default component.exports